<template lang="pug">
    div.select
        v-menu(offset-y)
            template(v-slot:activator="{ on }")
                div.moreWrapper(v-on="on")
                    div
                        div.label {{ label }}
                        div.activeText {{ activeText }}
                    div.icon
                        v-icon.moreIcon expand_more

            v-list
                v-list-tile(
                    v-for="(item, index) in selectParams"
                    :key="index"
                    @click="setValue(item)"
                )
                    v-list-tile-title(
                        v-if="flat"
                        :class="item === activeText ? 'isActive' : ''"
                    ) {{ item }}

                    v-list-tile-title(
                        v-else
                        :class="item.title === activeText ? 'isActive' : ''"
                    ) {{ item.title }}
</template>

<script>
    import VueTypes from 'vue-types';

    export default {
        props: {
            name: VueTypes.string.def(''),
            label: VueTypes.string.def(''),
            flat: VueTypes.bool.def(false),
            items: VueTypes.array.def([]),
            callbackFunction: VueTypes.func.def(() => {})
        },
        data() {
            return {
                activeText: 'All',
                allParam: {
                    title: 'All',
                    value: null
                }
            };
        },
        computed: {
            selectParams() {
                if (this.flat) return ['All', ...this.items];
                return [this.allParam, ...this.items];
            }
        },
        watch: {
            items() {
                this.activeText = 'All';
            }
        },
        methods: {
            setValue(item) {
                if (this.flat) {
                    this.callbackFunction({ value: item, name: this.name });
                    this.activeText = item;
                } else {
                    const { value, title } = item;
                    this.callbackFunction({ value: value, name: this.name });
                    this.activeText = title;
                }
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import "../../assets/style/_mixins.styl"
    @import "../../assets/style/_variables.styl";

    .select
        display: inline-block;

    .moreWrapper
        display: flex
        cursor: pointer

    .moreIcon
        background-color: rgba(249, 249, 249, 0.2);
        border-radius: 50%
        font-size: 22px
        color: $theme.white

    .label
        margin-right: 10px
        font-weight: 700
        font-size: remify(16px)

    .activeText
        font-size: remify(14px)

    >>>a
        &.v-list__tile--link
            &:hover,
            & > .isActive
                background: transparent !important
                color: $theme.action
</style>
